import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const hub = {
  hubList: (partnerId, params) => {
    const url = api.hub.list(partnerId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createHub: (partnerId, payloads) => {
    const url = api.hub.list(partnerId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  hubDetail: (partnerId, hubId) => {
    const url = api.hub.detail(partnerId, hubId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  deleteHub: (partnerId, hubId) => {
    const url = api.hub.detail(partnerId, hubId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  }
}
export default hub
